export default function() {
    return {
        settings: [],
        fields: [
            {
                key: 'name',
                label: 'Título'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
